import { defineStore } from 'pinia'

type State = {
  sales_people: SalesPerson[] | undefined,
  settings: {
    vat_percentage: number,
    sale_printable_seconds: number,
  },
}

export const useAppStore = defineStore('App', {
  state: (): State => ({
    sales_people: undefined,
    settings: {
      vat_percentage: 0,
      sale_printable_seconds: 0,
    },
  }),
  actions: {
    setSalesPeople (salesPeople: SalesPerson[]) {
      this.sales_people = salesPeople
    },
    setVatPercentage (vatPercentage: number) {
      this.settings.vat_percentage = vatPercentage
    },
    setSalePrintableSeconds (salePrintableSeconds: number) {
      this.settings.sale_printable_seconds = salePrintableSeconds
    },
  },
})
